import styles from "./index.module.scss";
import TemplatesTable from "./templates-table";
import { useEntity } from "../../../hooks/use-entity.hook";
import { Flaggers } from "../../../common/store/flaggers/flaggers.enum";
import { FlaggersMethods } from "../../../common/store/flaggers/flaggers.methods";
import InviteTemplateModal from "./invite-template-modal";
import { ModalData } from "../../../common/types/app.types";
import { useMemo } from "react";
import { 
  getEmailTemplateInitialValues, 
  emailTemplateValidationSchema 
} from "../../../common/validations/email-templates.validations";
import FormContent from "./invite-template-modal/form-options/invite-options";
import PreviewContent from "./invite-template-modal/preview-content/invite-content";

const EmailTemplates = () => {
  const { entityData: inviteTemplateModalData, setEntityData } = useEntity<ModalData>({ entityType: Flaggers.PreviewInviteTemplateFlagger })

  const handleOpenInviteTemplateModal = () => {
    setEntityData({ show: true }, FlaggersMethods.UpdateFlagger)
  }

  const handleCloseInviteTemplateModal = () => {
    setEntityData({ show: false }, FlaggersMethods.UpdateFlagger)
  }

  const initialValues = useMemo(() => getEmailTemplateInitialValues(), []);

  const handleSubmit = (values: typeof initialValues) => {
    console.log('Form submitted:', values);
  };

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className="m-0 f-16 line-height-24 f-600 f-black">Email Templates</h1>
        <TemplatesTable onPreviewInviteTemplate={handleOpenInviteTemplateModal} />
      </div>
      <InviteTemplateModal 
        title="Preview & Edit Template: Invites" 
        show={inviteTemplateModalData?.show} 
        onHide={handleCloseInviteTemplateModal}
        initialValues={initialValues}
        validationSchema={emailTemplateValidationSchema}
        formContentComponent={(formikProps) => <FormContent formikProps={formikProps} />}
        previewComponent={(formValues) => <PreviewContent formValues={formValues} />}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default EmailTemplates;
